import { useLanguage } from "@tlc/ls2pac/components/Language";
import { useLocationConfiguration } from "@tlc/ls2pac/components/LocationConfiguration";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import React from "react";

export interface ReadingLevelsProps {
  resource: ResourceDWR;
}
export const ReadingLevels: React.FC<ReadingLevelsProps> = ({ resource }) => {
  const { locationConfiguration } = useLocationConfiguration();
  const { translate } = useLanguage();

  if (!resource) {
    return null;
  }

  const lexileEnabled = locationConfiguration?.pacSettings?.lexileEnabled;
  const acceleratedReaderEnabled =
    locationConfiguration?.pacSettings?.acceleratedReaderEnabled;
  const { lexileDisplay } = resource.lexile;
  const { bookLevel } = resource.acceleratedReader;
  const displayBookLevel = acceleratedReaderEnabled && bookLevel;
  const displayLexile = lexileEnabled && lexileDisplay;

  return (
    <>
      {(displayLexile || displayBookLevel) && (
        <h4>
          {displayLexile && (
            <>
              {translate("lexileMeasure")}:{" "}
              <span className="lexile">{lexileDisplay}</span>
              {displayBookLevel && ", "}
            </>
          )}
          {displayBookLevel && (
            <>
              {translate("atosLevel")}:{" "}
              <span className="atos">{bookLevel}</span>
            </>
          )}
        </h4>
      )}
    </>
  );
};
